import { createFileRoute } from "@tanstack/react-router";

import { TasksPage } from "@onesolution/pages";

export const Route = createFileRoute("/app/_layout/tasks")({
	component: TasksPage,
});
